var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoading2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12.5021 2 12.9091 2.40701 12.9091 2.90909V6.54545C12.9091 7.04753 12.5021 7.45455 12 7.45455C11.4979 7.45455 11.0909 7.04753 11.0909 6.54545V2.90909C11.0909 2.40701 11.4979 2 12 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.5455C12.5021 16.5455 12.9091 16.9525 12.9091 17.4545V21.0909C12.9091 21.593 12.5021 22 12 22C11.4979 22 11.0909 21.593 11.0909 21.0909V17.4545C11.0909 16.9525 11.4979 16.5455 12 16.5455Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 11.4979 2.40701 11.0909 2.90909 11.0909H6.54545C7.04753 11.0909 7.45455 11.4979 7.45455 12C7.45455 12.5021 7.04753 12.9091 6.54545 12.9091H2.90909C2.40701 12.9091 2 12.5021 2 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5455 12C16.5455 11.4979 16.9525 11.0909 17.4545 11.0909H21.0909C21.593 11.0909 22 11.4979 22 12C22 12.5021 21.593 12.9091 21.0909 12.9091H17.4545C16.9525 12.9091 16.5455 12.5021 16.5455 12Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2208 15.2208C15.5758 14.8658 16.1514 14.8658 16.5065 15.2208L19.0778 17.7921C19.4328 18.1471 19.4328 18.7227 19.0778 19.0778C18.7227 19.4328 18.1471 19.4328 17.7921 19.0778L15.2208 16.5065C14.8658 16.1514 14.8658 15.5758 15.2208 15.2208Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0778 4.99349C19.4328 5.34851 19.4328 5.92411 19.0778 6.27914L16.5065 8.85043C16.1514 9.20545 15.5758 9.20545 15.2208 8.85043C14.8658 8.49541 14.8658 7.91981 15.2208 7.56478L17.7921 4.99349C18.1471 4.63846 18.7227 4.63846 19.0778 4.99349Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77919 15.2208C9.13421 15.5758 9.13421 16.1514 8.77919 16.5065L6.20789 19.0778C5.85287 19.4328 5.27726 19.4328 4.92224 19.0778C4.56722 18.7227 4.56722 18.1471 4.92224 17.7921L7.49354 15.2208C7.84856 14.8658 8.42417 14.8658 8.77919 15.2208Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92224 4.99349C5.27726 4.63846 5.85287 4.63846 6.20789 4.99349L8.77919 7.56478C9.13421 7.91981 9.13421 8.49541 8.77919 8.85043C8.42417 9.20545 7.84856 9.20545 7.49354 8.85043L4.92224 6.27914C4.56722 5.92411 4.56722 5.34851 4.92224 4.99349Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoading2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Loading2.16553108e82571f87fe1525768d3c1a3.svg";